/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Producer_PlaceholderInputs */

const en_search_producer_placeholder = /** @type {(inputs: Search_Producer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search producer...`)
};

const es_search_producer_placeholder = /** @type {(inputs: Search_Producer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar productor...`)
};

/**
* | output |
* | --- |
* | "Search producer..." |
*
* @param {Search_Producer_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_producer_placeholder = /** @type {((inputs?: Search_Producer_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Producer_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_producer_placeholder(inputs)
	return es_search_producer_placeholder(inputs)
});